import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { ProvinceClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.RegioneQuery],
  create: [SystemAuthorizations.RegioneAdd],
  edit: [SystemAuthorizations.RegioneUpdate],
  delete: [SystemAuthorizations.RegioneDelete],
});

export const headCells: HeadCell<ProvinceClient, keyof ProvinceClient>[] = [
  {
    id: 'code',
    label: 'Provincia',
  },
  {
    id: 'name',
    label: 'Nome provincia',
  },
  {
    id: 'region',
    label: 'Regione',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaProvinceFilter = yup.object({
  code: yup
    .string()
    .min(2, 'Il campo provincia deve essere almeno di 2 caratteri')
    .max(3, 'Il campo provincia deve essere al massimo di 3 caratteri')
    .matches(/(^\w{2}\*$)|(^\w{2}$)/gi, 'Il campo sigla provincia deve essere es: ci oppure ci*'),
  name: yup.string(),
  region: yup.string(),
});
